import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import CustomList from 'blocks.app/customList/customList'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { COMBO_CATALOG_CONFIG, COMBO_CATALOG_TITLE_KEY, ComboSelectedItems } from './InstancesCatalogCombo-types'

const InstancesCatalogComboComponent = () => {
    const [selectedItems, setSelectedItems] = useState<ComboSelectedItems>([])

    return (
        <Content title={COMBO_CATALOG_TITLE_KEY}>
            <CustomList
                type={COMBO_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                additionalData={COMBO_CATALOG_CONFIG.additionalData}
            />
        </Content>
    )
}

export const InstancesCatalogCombo = checkAvailableModule('instancesCatalog/combo')
    ? InstancesCatalogComboComponent
    : null
